module.exports = __webpack_public_path__ + "static/img/aside-fixed-icons.7f01ca34.png";